import { Popover } from 'antd'
import WizrFlexLayout from '../WizrFlexLayout'
import WizrButton from '../WizrButton'
import MoreIcon from '../../assets/icons/More'
import EditIcon from '../../assets/icons/EditIcon'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import ViewIcon from '../../assets/icons/ViewIcon'
import { useAuth } from '../../authContext'
import { useGetTenantDetails } from '../../redux/selectors/content'
const RolesActionPopoverContent = (rolesDetails: any): JSX.Element => {
  const { hasAcces } = useAuth();
  const navigate = useNavigate()
  const tenantDetails = useGetTenantDetails()
  const editRole = () => {
    //     showModal(MODAL_TYPES.UPDATE_ROLES,{
    //         roleDetails:rolesDetails?.rolesDetails,
    //       onCancel: hideModal,
    // })
    navigate('/userroles', { state: { role: rolesDetails?.rolesDetails, view: false } })
  }

  const onViewAction = () => {
    navigate('/userroles', { state: { role: rolesDetails?.rolesDetails, view: true } })
  }

  return (
    <WizrFlexLayout textAlign='left' background='#FFF'>
      <WizrButton
        icon={<ViewIcon />}
        text='View'
        type='text'
        onClick={() => {
          onViewAction()
        }}
        justifyContent='flex-start'
        disabled={!hasAcces('view_roles')}
      />
      <WizrButton
        icon={<EditIcon />}
        text='Edit'
        type='text'
        onClick={() => {
          editRole()
        }}
        justifyContent='flex-start'
        disabled={tenantDetails?.master_tenant ? false : rolesDetails?.rolesDetails?.is_default || !hasAcces('edit_roles')}
      />

      {/* <WizrButton
        disabled={rolesDetails?.rolesDetails?.is_default}
          icon={<DeleteIcon />}
          text='Delete'
          type='text'
          onClick={()=>{onDeleteAction()}}
          justifyContent='flex-start'
        /> */}
    </WizrFlexLayout>
  )
}

const RolesActionPopover = (rolesDetails: any): JSX.Element => {
  return (
    <Popover
      content={<RolesActionPopoverContent rolesDetails={rolesDetails?.rolesDetails} />}
      trigger='click'
    >
      <StyledButton
        icon={<MoreIcon />}
        text=''
        type='text'
        style={{ height: '40px', width: '40px', borderRadius: '50px' }}
      />
    </Popover>
  )
}
export default RolesActionPopover

const StyledButton = styled(WizrButton)`
  border-radius: 50%;
  width: 20px;
  height: 20px;
  padding-right: 8px;
  justify-content: center;
  align-items: center;
  /* Default styles */
  path {
    stroke: #999b9f; /* Default stroke color */
    transition: stroke 0.3s ease; /* Smooth transition for color change */
  }

  /* Hover styles */
  &:hover path {
    stroke: #1d1f22;
  }
`
